import type { Messages } from "../types";

export const cs = {
  "common": {
    "brand": "UN8",
    "brandTag": "Exkluzivní křesťanské seznamování",
    "continue": "Pokračovat",
    "leave": "Odejít",
    "leaveForNow": "Zatím odejít",
    "yes": "Ano",
    "no": "Ne",
    "goBack": "Zpět",
    "saving": "Ukládání…",
    "submitting": "Odesílání…",
    "pleaseWait": "Prosím čekejte…",
    "ellipsis": "…",
    "male": "Muž",
    "female": "Žena",
    "phases": {
      "gate": "Brána",
      "verify": "Ověření",
      "setup": "Nastavení",
      "profile": "Profil"
    },
    "storageQuota": "V tomto telefonu není dost místa pro uložené odpovědi. Uvolněte úložiště a zkuste to znovu.",
    "storageDisabled": "Tento prohlížeč neuloží vaše odpovědi. Vypněte režim inkognito nebo povolte data webu a znovu načtěte stránku.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min. {min} znaků"
  },
  "welcome": {
    "promise": "Naším cílem je, abyste tuto aplikaci smazali co nejdříve.",
    "sub": "UN8 pomáhá vážným křesťanským singles najít životního partnera — a pak odejít. Ověřeno. Hodnoty na prvním místě. Žádné nekonečné swipování.",
    "signedInAs": "Přihlášen jako {email}",
    "liveServer": " · živý server",
    "deviceOnly": " · pouze toto zařízení",
    "migrateOffer": "Toto zařízení má stále místní profil. Nahrát ho na sdílený server, aby vás po moderaci viděly i jiné telefony? Nic se nenahraje, dokud nezvolíte.",
    "uploadLocalProfile": "Nahrát můj místní profil",
    "keepOnDevice": "Nechat jen na tomto zařízení",
    "migrateNeedGender": "Nejprve v profilu zvolte Muž nebo Žena.",
    "migrateDone": "Text profilu nahrán. Znovu nahrajte doklad, video a fotografie, aby je moderace mohla zkontrolovat.",
    "deleteConfirm": "Trvale smazat váš účet, všechny zprávy a všechna média (včetně dokladu a videa) ze serveru?",
    "accountDeleted": "Účet smazán.",
    "begin": "Začít",
    "continueOnboarding": "Pokračovat v registraci",
    "logIn": "Přihlásit se",
    "logOut": "Odhlásit se",
    "reviewConsole": "Kontrolní konzole",
    "matching": "Párování",
    "deleteMyAccount": "Smazat můj účet"
  },
  "faith": {
    "eyebrow": "Brána víry",
    "title": "Pouze křesťané",
    "text": "UN8 je společenství následovníků Ježíše Krista pro členy, kteří hledají partnera orientovaného na manželství, který sdílí tutéž víru. Tuto bránu nelze přeskočit.",
    "yesTitle": "Jsem křesťan",
    "yesBody": "Následuji Ježíše Krista a hledám partnera orientovaného na manželství, který sdílí tuto víru.",
    "noTitle": "Nejsem křesťan",
    "noBody": "UN8 pro mě není to pravé místo — a to je v pořádku.",
    "respectTitle": "S úctou",
    "respectBody": "UN8 je postaven pro jedno společenství a raději jsme upřímní, než abychom plýtvali vaším časem. Použijte níže Odejít, nebo Zpět, pokud to není váš domov.",
    "sharedTitle": "Společný základ",
    "sharedBody": "Víra zde není štítek. Je to půda, na které se setkáváte.",
    "hintNotChristian": "UN8 je pro následovníky Ježíše Krista. Klepněte níže na Odejít, nebo zvolte křesťanskou možnost, pokud jste to vy.",
    "hintUnset": "Klepněte na „Jsem křesťan“ pro pokračování, nebo Odejít / Zpět, pokud to není váš domov."
  },
  "rules": {
    "eyebrow": "Smlouva společenství",
    "title": "Jak se k sobě chováme",
    "text": "Potvrďte každé pravidlo. Všechna tři jsou povinná. Porušení vedou k trvalému odstranění. Falešné profily jsou zakázány navždy.",
    "agreeContinue": "Souhlasím — pokračovat",
    "respectful": {
      "title": "Buďte uctiví",
      "description": "Mluvte a jednejte s důstojností. Každý člověk zde je stvořen k Božímu obrazu."
    },
    "noSexualContent": {
      "title": "Žádný sexuální obsah",
      "description": "Žádné explicitní fotografie, zprávy ani žádosti. Čistota zde není volitelná."
    },
    "noDominance": {
      "title": "Nedominujte a nekontrolujte",
      "description": "Žádné nátlaky, manipulace ani tlak. Láska neovládá."
    },
    "hint": "Zaškrtněte všechny tři sliby, než budete pokračovat."
  },
  "intent": {
    "eyebrow": "",
    "title": "Co hledáš?",
    "text": "",
    "marriage": {
      "label": "Životního partnera",
      "description": ""
    },
    "discernment": {
      "label": "Vážné rozlišování",
      "description": ""
    },
    "notCasual": {
      "label": "Nic nahodilého",
      "description": ""
    },
    "hint": "Vyber jedno."
  },
  "account": {
    "eyebrow": "Účet",
    "title": "Vytvořte si přístup",
    "text": "Váš handle vytvoří stabilní uživatelské id. Přihláška, ověření, lajky a páry se vážou k tomuto id. Žádný e-mail se neodesílá.",
    "recoveryTitle": "Uložte si obnovovací kód",
    "recoveryText": "Zobrazen jednou. Bez něj nelze v tomto uzavřeném testu resetovat ztracenou přístupovou frázi.",
    "savedContinue": "Uložil jsem si ho — pokračovat",
    "handle": "Handle",
    "handlePlaceholder": "vy@priklad.com nebo krátký handle",
    "passphrase": "Přístupová fráze",
    "passphrasePlaceholder": "Alespoň 8 znaků",
    "signedInTitle": "Přihlášen",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Standard důvěry",
    "trustBody": "Žádný profil není viditelný, dokud není dokončeno ověření identity a moderace vás neschválí.",
    "continueToVerification": "Pokračovat k ověření",
    "hintEmail": "Zadejte e-mailovou adresu, která obsahuje @.",
    "hintPassword": "Zvolte heslo alespoň 8 znaků."
  },
  "verify": {
    "intro": {
      "eyebrow": "Ověření",
      "title": "Důvěra je brána",
      "text": "Nahrajte vládní doklad, potvrzovací video a {min}–{max} skutečných fotografií. Vše vstupuje do fronty kontroly, než se váš profil může zobrazit.",
      "whyTitle": "Proč ověřujeme",
      "whyBody": "Catfishing a polopravdy zde nemají místo. Falešné profily jsou trvale zakázány. Média se ukládají se stavem pending_review, dokud nejsou schválena.",
      "start": "Spustit ověření"
    },
    "steps": {
      "id": {
        "title": "Vládní doklad",
        "description": "Pas nebo občanský průkaz — kamera nebo nahrání souboru."
      },
      "video": {
        "title": "Potvrzovací video",
        "description": "Krátký záznam, který dokazuje, že jste přítomni."
      },
      "photos": {
        "title": "Skutečné fotografie",
        "description": "Sedm až deset jasných fotografií sebe sama."
      },
      "review": {
        "title": "Kontrola integrity",
        "description": "Nahrávky zůstávají pending_review, dokud je personál nepotvrdí."
      }
    },
    "id": {
      "eyebrow": "Krok 1 z 4",
      "title": "Vládní doklad",
      "text": "Vyfoťte nebo nahrajte pas či občanský průkaz. Nic se neveřejní — stav zůstává pending_review, dokud personál nepotvrdí.",
      "savedTitle": "Doklad uložen",
      "savedBody": "Další je krátké potvrzovací video vaší tváře, pak 7 až 10 skutečných fotografií sebe. Pokračovat se odemkne, až bude tento doklad označen jako uložený.",
      "hint": "Vyfoťte nebo nahrajte fotografii vládního dokladu a počkejte, až bude uloženo."
    },
    "video": {
      "eyebrow": "Krok 2 z 4",
      "title": "Potvrzovací video",
      "text": "Nahrajte krátký klip nebo jeden nahrajte. Dívejte se do kamery. Mluvte jasně. To dokazuje, že jste přítomni — ne seškrábaná galerie.",
      "hint": "Nahrajte krátké potvrzovací video a počkejte, až bude uloženo."
    },
    "photos": {
      "eyebrow": "Krok 3 z 4",
      "title": "Skutečné fotografie",
      "text": "Přidejte {min}–10 nedávných fotografií sebe. Použijte kameru nebo knihovnu. Klepnutím na × odstraníte jakýkoli snímek.",
      "continueToReview": "Pokračovat ke kontrole",
      "hint": "Přidejte {min} až 10 jasných fotografií sebe. Pokračovat se odemkne, až budou uloženy."
    },
    "review": {
      "eyebrow": "Krok 4 z 4",
      "title": "Kontrola integrity",
      "text": "Média jsou ve frontě jako pending_review{underUser}. Páry a lajky použijí stejné id.",
      "underUser": " pod uživatelem {userId}",
      "governmentId": "Vládní doklad",
      "confirmationVideo": "Potvrzovací video",
      "photos": "Fotografie",
      "missing": "Chybí",
      "filesReady": "{count} souborů připraveno",
      "submittedTitle": "Odesláno ke kontrole",
      "submittedText": "Id přihlášky se rovná auth user id, aby schválení → pool a vzájemné lajky zůstaly v souladu.",
      "submitContinue": "Odeslat a pokračovat"
    }
  },
  "setup": {
    "eyebrow": "Nastavení účtu",
    "title": "Říkejte o sobě pravdu",
    "text": "Tyto odpovědi formují párování a objeví se v kontrole. Mírné lži plýtvají časem všech — včetně vás.",
    "beginSetup": "Začít nastavení",
    "pillars": {
      "faith": {
        "name": "Víra",
        "text": "Proč následujete Krista."
      },
      "character": {
        "name": "Charakter",
        "text": "Věrnost, upřímnost, vášeň, závazek — hodnocení 1–10."
      },
      "story": {
        "name": "Příběh",
        "text": "Kdo jste a co hledáte."
      },
      "life": {
        "name": "Život",
        "text": "Koníčky, čtení a povolání."
      }
    },
    "whyChristian": {
      "eyebrow": "Víra",
      "title": "Proč jste křesťan?",
      "text": "Krátká, upřímná odpověď. Ne kázání — důvod, který je váš.",
      "label": "Vaše odpověď",
      "placeholder": "např. Setkal jsem se s Kristem v období ztráty a od té doby Ho následuji…",
      "hint": "Napište alespoň {min} znaků o tom, proč následujete Ježíše."
    }
  },
  "scales": {
    "eyebrow": "Škály charakteru",
    "title": "Ohodnoťte se upřímně",
    "text": "Věrnost, upřímnost, vášeň, závazek — každá od 1 do 10. Nafouknutá čísla vás později jen špatně spárují. Pro pokračování musíte nastavit každou škálu.",
    "loyalty": {
      "label": "Úroveň věrnosti",
      "hint": "Buďte upřímní — jak věrně stojíte při těch, které milujete?"
    },
    "honesty": {
      "label": "Úroveň upřímnosti",
      "hint": "Jak důsledně říkáte celou pravdu?"
    },
    "passion": {
      "label": "Jak jste vášniví?",
      "hint": "Přesvědčení a hloubka — ne představení."
    },
    "commitment": {
      "label": "Úroveň závazku",
      "hint": "Jak jste připraveni budovat něco trvalého?"
    },
    "hint": "Posuňte každý posuvník, aby se zobrazilo číslo — žádný nesmí zůstat jako pomlčka."
  },
  "about": {
    "eyebrow": "O vás",
    "title": "Popište se v několika větách",
    "text": "Kdo jste, když nikdo nehraje roli. Temperament, rytmus, co denně záleží.",
    "label": "O vás",
    "placeholder": "Tichá rána, vážně o rodině, snadno se směju, preferuji hloubku před hlukem…",
    "hint": "Napište o sobě alespoň {min} znaků."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Co hledáte?",
    "text": "Hlavní charakterové rysy, které si přejete u potenciálního partnera — ne nákupní seznam vzhledu.",
    "label": "Požadované charakterové rysy",
    "placeholder": "např. Stálá víra, emoční zralost, laskavost pod stresem…",
    "hint": "Napište alespoň {min} znaků o partnerovi, kterého si přejete."
  },
  "loveReady": {
    "eyebrow": "Práh",
    "title": "Jste připraveni potkat lásku svého života?",
    "text": "UN8 existuje, aby vážní singles našli partnera — a pak smazali aplikaci. Pouze „Ano“ odemyká pokračování.",
    "yesTitle": "Ano — jsem připraven",
    "yesBody": "Jsem tu, abych potkal svého člověka s jasností a odvahou.",
    "noTitle": "Ještě ne",
    "noBody": "Pokud jen prohlížíte, toto společenství není to pravé.",
    "comeBackTitle": "Vraťte se, až budete připraveni",
    "comeBackBody": "UN8 je pro lidi připravené potkat — ne sbírat možnosti. Použijte níže Odejít, pokud chcete teď přestat. Vaše odpovědi jsou uloženy v tomto telefonu.",
    "hintNo": "Pouze „Ano“ pokračuje. Pokud nejste připraveni, klepněte na Zatím odejít — odpovědi zůstanou v tomto telefonu.",
    "hintUnset": "Klepněte na Ano, pokud jste připraveni potkat někoho pro manželství."
  },
  "lifestyle": {
    "eyebrow": "Životní styl",
    "title": "Jak žijete den za dnem",
    "text": "Sport, koníčky, čtení a povolání — praktické signály skutečné kompatibility.",
    "hobbies": "Současný sport nebo koníčky",
    "hobbiesPlaceholder": "Co aktivně děláte — ne to, co jste kdysi dělali jednou.",
    "reading": "Čtete?",
    "readingHint": "1 = téměř nikdy · 10 = denní, hluboké čtení",
    "profession": "Povolání / odvětví",
    "professionPlaceholder": "např. Ošetřovatelství · Software · Vzdělávání · Řemesla",
    "hintHobbies": "Uveďte alespoň jeden sport nebo koníček, který skutečně děláte.",
    "hintReading": "Posuňte „Čtete?“ tak, aby se zobrazilo číslo od 1 do 10.",
    "hintProfession": "Napište práci, kterou děláte, i krátké slovo."
  },
  "faithDepth": {
    "eyebrow": "Párování · Víra",
    "title": "Jak ústřední je vaše víra?",
    "text": "Služba Bohu — jak důležitá ve vašem životě? Odpovězte upřímně. Párování to používá pro hloubku, ne pro představení.",
    "serving": "Služba Bohu — důležitost",
    "servingHint": "10 % … 100 %. Posouvejte po krocích 10.",
    "keepsCommandments": "Dodržujete přikázání?",
    "grewUpInChurch": "Vyrostli jste v církvi?",
    "churchAttendance": "Návštěva bohoslužeb",
    "frequent": {
      "label": "Často",
      "hint": "Pravidelné shromažďování s tělem Kristovým."
    },
    "seldom": {
      "label": "Zřídka",
      "hint": "Příležitostně, ne týdenní rytmus."
    },
    "never": {
      "label": "Nikdy",
      "hint": "Momentálně nenavštěvuji."
    },
    "spreadsGospel": "Šíříte evangelium?",
    "hasIdols": "Máte idoly?",
    "hintServing": "Posuňte, jak důležitá je služba Bohu ve vašem životě.",
    "hintCommandments": "Odpovězte, zda dodržujete přikázání — Ano nebo Ne.",
    "hintGrewUp": "Odpovězte, zda jste vyrostli v církvi — Ano nebo Ne.",
    "hintAttendance": "Zvolte, jak často navštěvujete bohoslužby.",
    "hintGospel": "Odpovězte, zda sdílíte evangelium — Ano nebo Ne.",
    "hintIdols": "Odpovězte, zda máte idoly — Ano nebo Ne."
  },
  "character": {
    "eyebrow": "Párování · Charakter",
    "title": "Kdo jste doma",
    "text": "Charakter pro námluvy — peacemaking, slušnost, upřímnost. Nafouknuté odpovědi vás později jen špatně spárují.",
    "peacemaker": "Jste peacemaker?",
    "homebuilder": "Jste budovatel domova?",
    "humorous": "Jste humorní?",
    "caring": "Pečující a láskyplní?",
    "peacefulHome": "Chcete pokojný domov — bez hádek?",
    "manners": "Dobré způsoby?",
    "honestyRating": "Hodnocení upřímnosti v tomto dotazníku",
    "honestyHint": "1–10 — jak upřímně odpovídáte?",
    "hintPeacemaker": "Odpovězte Ano nebo Ne na každou otázku, začněte peacemakerem.",
    "hintHomebuilder": "Odpovězte, zda jste budovatel domova.",
    "hintHumorous": "Odpovězte, zda jste humorní.",
    "hintCaring": "Odpovězte, zda jste pečující a láskyplní.",
    "hintPeaceful": "Odpovězte, zda chcete pokojný domov.",
    "hintManners": "Odpovězte, zda máte dobré způsoby.",
    "hintHonesty": "Posuňte hodnocení upřímnosti od 1 do 10."
  },
  "history": {
    "eyebrow": "Párování · Historie",
    "title": "Minulost a připravenost",
    "text": "Návykové látky, dětství, jizvy a zda jste připraveni na trvalý vztah. Pravda zde chrání oba.",
    "marijuana": "Užívali jste marihuanu?",
    "lsd": "Užívali jste LSD?",
    "otherDrugs": "Užívali jste jiné drogy?",
    "addicted": "Byli jste závislí?",
    "childhood": "Stabilní, milující dětství?",
    "scars": "Nějaké jizvy / poškození?",
    "lasting": "Připraveni na trvalý vztah?",
    "hintStart": "Odpovězte Ano nebo Ne na každou otázku na této stránce, začněte nahoře.",
    "hintLsd": "Odpovězte na otázku o LSD — Ano nebo Ne.",
    "hintOtherDrugs": "Odpovězte, zda jste užívali jiné drogy.",
    "hintAddicted": "Odpovězte, zda jste byli závislí.",
    "hintChildhood": "Odpovězte, zda bylo vaše dětství stabilní a milující.",
    "hintScars": "Odpovězte, zda nesete jizvy.",
    "hintLasting": "Odpovězte, zda jste připraveni na trvalý vztah."
  },
  "appearance": {
    "eyebrow": "Párování · Vzhled",
    "title": "Tetování",
    "text": "Vaše tetování a zda jsou tetování na partnerovi pro vás přijatelná.",
    "hasTattoos": "Máte tetování?",
    "acceptsPartner": "Přijímáte tetování u partnera?",
    "hintHas": "Řekněte, zda máte tetování — Ano nebo Ne.",
    "hintAccepts": "Řekněte, zda jsou tetování u partnera pro vás přijatelná."
  },
  "home": {
    "eyebrow": "Párování · Domov a země",
    "title": "Země, dovednosti, soběstačnost",
    "text": "Byliny, pěstování jídla, ovocný les, příprava, komunitní zemědělství, zavařování, přežití — a jakékoli zvláštní dovednosti.",
    "herbKnowledge": "Znalost bylin?",
    "plantOwn": "Sázíte vlastní ovoce a zeleninu?",
    "fruitForest": "Zajímá vás ovocný les?",
    "prepping": "Připravujete se na pohromy?",
    "communityFarming": "Komunitní zemědělství / nezávislé bydlení?",
    "canning": "Zavařování a konzervování?",
    "survival": "Dovednosti přežití?",
    "specialSkills": "Zvláštní dovednosti (volitelné)",
    "specialPlaceholder": "Cokoli dalšího, co přinášíte do domácnosti nebo na pozemek…",
    "hintStart": "Odpovězte Ano nebo Ne na každou otázku o zemi a dovednostech, začněte nahoře.",
    "hintPlant": "Odpovězte, zda sázíte vlastní ovoce a zeleninu.",
    "hintFruitForest": "Odpovězte, zda vás ovocný les zajímá.",
    "hintPrepping": "Odpovězte, zda se připravujete na pohromy.",
    "hintCommunity": "Odpovězte, zda vás zajímá komunitní zemědělství.",
    "hintCanning": "Odpovězte, zda zavařujete a konzervujete potraviny.",
    "hintSurvival": "Odpovězte, zda máte dovednosti přežití."
  },
  "family": {
    "eyebrow": "Párování · Rodina",
    "title": "Děti, hloubka víry, látky",
    "text": "Co potřebujete u partnera ohledně intenzity víry, dětí a minulého užívání látek.",
    "children": "Děti",
    "wants": {
      "label": "Chce děti",
      "hint": "Budování rodiny je součástí vize."
    },
    "doesNotWant": {
      "label": "Nechce děti",
      "hint": "Jasné ne k dětem."
    },
    "open": {
      "label": "Otevřený",
      "hint": "Rozlišování — nezamčeno ani jedním směrem."
    },
    "hasLivingWith": {
      "label": "Má děti — žije s nimi",
      "hint": "Děti jsou už součástí každodenního života."
    },
    "requiredFaith": "Minimální úroveň víry, kterou potřebujete u partnera",
    "requiredFaithHint": "10 % … 100 %. Tvrdá brána, když obě strany odpověděly.",
    "acceptsSubstances": "Přijímáte minulé užívání látek u partnera?",
    "hintChildren": "Zvolte jednu kartu o dětech.",
    "hintFaith": "Posuňte minimální úroveň víry, kterou u partnera očekáváte.",
    "hintSubstances": "Řekněte, zda je minulé užívání látek u partnera přijatelné."
  },
  "ancestry": {
    "eyebrow": "Párování · Původ",
    "title": "Preference původu",
    "text": "Sdílejte svůj původ a to, čemu jste otevřeni u partnera. To pouze formuje pořadí — nikdy nikoho neskrývá z balíčku.",
    "yourBackground": "Váš původ (vyberte vše, co platí)",
    "openToPartner": "Otevřený u partnera",
    "codeDesc": "Kód: {code}",
    "anyDesc": "Nejsilnější preference šířky — doporučeno, když si nejste jisti.",
    "preferenceOnly": "Pouze preference — ne brána.",
    "hintOwn": "Zaškrtněte alespoň jeden původ, který vás popisuje. To pouze pomáhá pořadí — nikdy nikoho neskrývá.",
    "hintAccepted": "Zaškrtněte, čemu jste otevřeni u partnera, nebo „Otevřený — bez preference“."
  },
  "interests": {
    "eyebrow": "Párování · Zájmy",
    "title": "Co vás baví",
    "text": "Vyberte alespoň jeden. Překryv pomáhá pořadí; mlčení se nikdy netrestá.",
    "hint": "Zaškrtněte alespoň jeden zájem."
  },
  "reflection": {
    "eyebrow": "Párování · Reflexe",
    "title": "Vlastními slovy",
    "text": "Tyto čtyři odpovědi se zobrazují celé a nikdy se nebodují. Pište, co je pravda.",
    "describeYourself": "Popište sebe",
    "lifePurpose": "Životní účel",
    "fifteenYear": "Vy a láska vašeho života za 15 let",
    "weaknesses": "Slabosti",
    "hintDescribe": "Popište sebe alespoň v {min} znacích.",
    "hintPurpose": "Napište svůj životní účel alespoň v {min} znacích.",
    "hintVision": "Napište 15letou vizi alespoň v {min} znacích.",
    "hintWeaknesses": "Uveďte slabost alespoň v {min} znacích."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Několik základů",
    "text": "Udržte to jednoduché. Pohlaví je zde binární — muž nebo žena — pro jasné párování.",
    "firstName": "Křestní jméno",
    "firstNamePlaceholder": "Jak chcete být známí",
    "age": "Věk",
    "agePlaceholder": "18+",
    "city": "Město",
    "cityPlaceholder": "Kde sídlíte",
    "sex": "Pohlaví",
    "maleBody": "Jsem muž.",
    "femaleBody": "Jsem žena.",
    "hintName": "Zadejte křestní jméno (alespoň dvě písmena).",
    "hintAge": "Věk musí být 18 nebo více.",
    "hintCity": "Zadejte město, kde žijete.",
    "hintGender": "Zvolte Muž nebo Žena, aby párování fungovalo."
  },
  "ready": {
    "title": "Můžete vstoupit.",
    "textNamed": "{name}, vaše ověření a nastavení jsou zaznamenány. Média jsou pending_review. Vítejte v UN8 — najděte svého člověka a pak smažte aplikaci.",
    "text": "Vaše ověření a nastavení jsou zaznamenány. Média jsou pending_review. Vítejte v UN8 — najděte svého člověka a pak smažte aplikaci.",
    "summaryAria": "Souhrn nastavení",
    "christianRules": "Křesťan · pravidla potvrzena",
    "mediaLine": "Doklad · video · {photoCount} fotografií · fronta {pending}",
    "scalesLine": "Škály L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Pohlaví —",
    "professionFallback": "povolání",
    "userLine": "Uživatel {userId}",
    "enterMatching": "Vstoupit do párování",
    "needGender": "Vraťte se ke kroku profilu, zvolte Muž nebo Žena a zkuste to znovu."
  },
  "match": {
    "brandTag": "Párování",
    "navOnboarding": "Registrace",
    "navReview": "Kontrola",
    "navMatching": "Párování",
    "logOut": "Odhlásit se",
    "enterTitle": "Vstoupit do párování",
    "enterText": "Přihlaste se stejným e-mailem jako při registraci. Přihláška, pool, lajky a páry používají vaše stabilní uživatelské id.",
    "email": "E-mail",
    "emailPlaceholder": "vy@priklad.com",
    "password": "Heslo",
    "passwordPlaceholder": "Vaše heslo",
    "logIn": "Přihlásit se",
    "guestOr": "Nebo vyzkoušejte hostovskou relaci (stabilní id na prohlížeč · pouze demo)",
    "guestMan": "Host jako muž",
    "guestWoman": "Host jako žena",
    "goOnboarding": "Přejít k registraci →",
    "guestSession": "Hostovská relace · demo pool",
    "packTitle": "Tvoje čtyři",
    "packSkip": "Klepni pro pokračování",
    "newSelection": "Nový výběr",
    "backToFour": "← Zpět ke svým čtyřem",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "muž",
    "woman": "žena",
    "navSelection": "Výběr",
    "navMessages": "Zprávy",
    "navProfile": "Profil",
    "tabToday": "Výběr",
    "tabMatches": "Páry ({count})",
    "yourMatches": "Vaše páry",
    "matchesSub": "Trvalý vzájemný zájem · {count} odchozích {likesWord}",
    "like": "lajk",
    "likes": "lajků",
    "emptyMatches": "Zatím žádný vzájemný zájem. Pokračuj v rozlišování týdenního výběru.",
    "valuesScore": "Hodnoty {score}",
    "chatOpen": " · Chat otevřen",
    "tapToChat": " · Klepněte pro chat",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Hodnoty {score}",
    "noProfileYet": "Zatím žádný profil",
    "noProfileText": "Dokončete registraci, nebo nahoře klepněte na Registrace a pak Začít. Hostovské párování je na vstupní obrazovce, pokud se jen chcete dívat.",
    "matchingPaused": "Párování pozastaveno",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Zatím není koho ukázat",
    "todaysSetDone": "To je výběr tohoto týdne",
    "weeklyTitle": "Tvoji 4 tento týden",
    "weeklyTitleCount": "Tvoji {count} tento týden",
    "weeklyCountdown": "Další výběr za {days} dní",
    "weeklyCountdownOne": "Další výběr za 1 den",
    "weeklyCountdownSoon": "Další výběr brzy",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "To je výběr tohoto týdne",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Na seznamu tohoto týdne zatím nikdo není. Pool se plní — otevři Výběr za chvíli, nebo se vrať, až schválíme další členy.",
    "emptyDone": "Prošel jsi výběr tohoto týdne. Vrať se při dalším otevření, nebo resetuj balíček.",
    "likesMayNotStick": " Lajky se nemusí uchovat.",
    "poolMeta": "Pool: {pool} · Páry: {matches} · Lajknuto: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Resetovat balíček",
    "backOnboarding": "Zpět k registraci",
    "feedEyebrowDemo": "Týdenní výběr · Demo",
    "feedEyebrowLive": "Týdenní výběr · Pool ({source}, {count})",
    "feedTitle": "Rozlišujte pečlivě",
    "left": "zbývá {count}",
    "pass": "Přeskočit",
    "interested": "Mám zájem",
    "swipeHint": "Přejeďte nebo použijte tlačítka. Pár se otevře jen když je zájem vzájemný a trvalý.",
    "celebrationEyebrow": "Vzájemný zájem",
    "celebrationTitle": "Shodli jste se",
    "celebrationText": "{self} a {other} oba projevili zájem. Soulad hodnot: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Chat je pro tento pár odemčen. Buďte uctiví — smlouva nad pohodlím.",
    "openChat": "Otevřít chat",
    "keepDiscerning": "Pokračovat v rozlišování",
    "cardSeeking": "Hledá",
    "cardHobbies": "Koníčky",
    "affinity": "Afinita",
    "valuesScoreLabel": "Skóre hodnot",
    "scoreStrong": "Silný soulad",
    "scoreSolid": "Pevný soulad",
    "scoreModerate": "Mírný soulad",
    "scoreDifferent": "Odlišné rytmy",
    "characterAxisFoot": "Osa charakteru zahrnuje čtyři pilíře",
    "youThem": "Vy {self} · Oni {other}",
    "stampInterest": "Zájem",
    "stampPass": "Přeskočit",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Vaše skóre hodnot jsou blízko sebe ({score} ze 100).",
    "explainLegacyFuller": "Úplnější „proč“ se objeví, až oba dokončíte párovací otázky.",
    "explainFaith": "Intenzita vaší víry je blízká — následujete Ježíše s podobnou vážností.",
    "explainCharacter": "Jak se chováte k lidem doma se shoduje — pokoj, způsoby a péče.",
    "explainPurpose": "Podobně jste ohodnotili vlastní upřímnost, což je znamení společné vážnosti.",
    "explainHome": "Sdílíte zájem o zemi, pěstování jídla nebo soběstačný domov.",
    "explainAncestry": "Oba preferujete podobné rodinné zázemí. To je preference, ne filtr — nikdo kvůli tomu není skryt.",
    "explainTemperament": "Vaše zájmy a temperament se překrývají.",
    "explainFallback": "Na odpovědích, které jste oba vyplnili, je možná shoda.",
    "explainOverall": "Celková afinita {score} ze 100.",
    "affinityAxes": {
      "faith": "Intenzita víry",
      "character": "Charakter a chování",
      "purpose": "Soulad životního účelu",
      "home": "Domov a soběstačnost",
      "ancestry": "Kulturní a původová afinita",
      "temperament": "Soulad temperamentu"
    },
    "scaleAxes": {
      "loyalty": "Věrnost",
      "honesty": "Upřímnost",
      "passion": "Vášeň",
      "commitment": "Závazek"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat nedostupný",
    "unavailableText": "Tento pár chybí nebo nepatří k vaší relaci.",
    "backToMatches": "Zpět k párům",
    "backMatches": "← Páry",
    "valuesSubscriber": "Hodnoty {score} · Předplatitel",
    "valuesTrial": "Hodnoty {score} · Zkušební",
    "valuesKept": "Hodnoty {score} · Pár zachován",
    "empty": "Pozdravte s péčí. Na sdíleném backendu se zprávy synchronizují na oba telefony po vzájemném páru.",
    "placeholder": "Zpráva {name}…",
    "ariaMessage": "Zpráva",
    "send": "Odeslat"
  },
  "billing": {
    "paywallCopy": "Po bezplatné zkušební době si ponechte každého, s kým jste se už shodli, a pokračujte v chatu. Chcete-li vidět nové lidi, předplaťte si.",
    "signInToMatch": "Přihlaste se pro párování.",
    "signInFirst": "Nejprve se přihlaste.",
    "subscriberUntil": "Předplatitel · do {date}",
    "renewal": "obnovení",
    "freeTrial": "Bezplatná zkušební doba · {days} dní (končí {date})",
    "soon": "brzy",
    "trialEnded": "Zkušební doba skončila · páry a chat zůstávají otevřené",
    "subscribe": "Předplatit · ${price}/měs.",
    "subscribeEarly": "Předplatit brzy · ${price}/měs.",
    "activeNote": "Předplatné aktivní — opět můžete vidět nové lidi.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Uložte si obnovovací kód",
    "recoveryText": "Zapište si ho teď. Zobrazí se jednou. Pokud ztratíte přístupovou frázi, je tento kód v uzavřeném testu jediný způsob resetu.",
    "savedContinue": "Uložil jsem si ho — pokračovat",
    "welcomeBack": "Vítejte zpět",
    "createAccount": "Vytvořte si účet",
    "intro": "Handle a přístupová fráze. Neodesílá se e-mail ani SMS. Vaše id zůstává stabilní napříč registrací, kontrolou a párováním.",
    "tabLogin": "Přihlásit se",
    "tabRegister": "Registrovat",
    "handle": "Handle",
    "handlePlaceholder": "vy@priklad.com nebo krátký handle",
    "passphrase": "Přístupová fráze",
    "passphrasePlaceholder": "Alespoň 8 znaků",
    "submitLogin": "Přihlásit se",
    "submitRegister": "Vytvořit účet",
    "backWelcome": "Zpět na úvod"
  },
  "options": {
    "origin": {
      "african": "Africký",
      "european": "Evropský",
      "asian": "Asijský",
      "latino": "Latino / hispánský",
      "middleEastern": "Blízkovýchodní",
      "indigenous": "Domorodý",
      "mixed": "Smíšený",
      "other": "Jiný",
      "dutch": "Nizozemský",
      "german": "Německý",
      "any": "Otevřený — bez preference"
    },
    "interest": {
      "prayer": "Modlitba",
      "worship": "Chvála",
      "reading": "Čtení",
      "hiking": "Turistika",
      "music": "Hudba",
      "cooking": "Vaření",
      "farming": "Farmaření / zahradnictví",
      "sports": "Sport",
      "missions": "Mise",
      "family": "Rodinný život",
      "crafts": "Řemesla",
      "outdoors": "Venku"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Ano",
      "no": "Ne"
    },
    "id": {
      "titleEmpty": "Vládní doklad",
      "titleReady": "Doklad připraven",
      "hintEmpty": "Pas nebo občanský průkaz. Pořiďte živou fotografii, nebo zvolte obrázek/PDF. Všechny čtyři rohy viditelné.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · uloženo",
      "previewAlt": "Náhled vládního dokladu",
      "pdfAria": "Vybrán dokument PDF",
      "takePhoto": "Pořídit fotografii",
      "retake": "Znovu",
      "chooseFile": "Zvolit soubor",
      "replaceFile": "Nahradit soubor",
      "remove": "Odstranit",
      "uploading": "Nahrávání…",
      "cameraTitle": "Vyfotografujte svůj doklad",
      "signIn": "Před nahráním dokladu se přihlaste.",
      "uploadFailed": "Nahrání selhalo. Zkuste to znovu.",
      "badFile": "Tento soubor nelze použít."
    },
    "video": {
      "titleEmpty": "Potvrzovací video",
      "titleLive": "Kamera živě",
      "titleReady": "Video připraveno",
      "hintEmpty": "Řekněte své křestní jméno a že se k UN8 připojujete upřímně. 5–15 sekund.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Nahrát",
      "cameraUpload": "Nahrání z kamery",
      "chooseFile": "Zvolit soubor",
      "startRecording": "Spustit nahrávání",
      "cancel": "Zrušit",
      "stopSave": "Zastavit a uložit",
      "recordAgain": "Nahrát znovu",
      "replaceFile": "Nahradit soubor",
      "remove": "Odstranit",
      "unsupported": "Živé nahrávání zde není dostupné. Použijte nahrání z kamery nebo zvolte soubor.",
      "permissionDenied": "Oprávnění kamery odepřeno. Stále můžete nahrát krátký video soubor.",
      "signIn": "Před nahráním videa se přihlaste.",
      "uploadFailed": "Nahrání selhalo. Zkuste to znovu.",
      "saveFailed": "Nahrávku nelze uložit.",
      "badVideo": "Toto video nelze použít."
    },
    "photos": {
      "count": "{count} / {max} fotografií",
      "minimumMet": "Minimum splněno",
      "moreRequired": "Ještě {n} potřeba",
      "listAria": "Ověřovací fotografie",
      "photoAlt": "Fotografie {n}",
      "removeAria": "Odstranit fotografii {n}",
      "camera": "Kamera",
      "takePhoto": "Pořídit fotografii",
      "chooseFiles": "Zvolit soubory",
      "uploading": "Nahrávání…",
      "hint": "Pořídit fotografii otevře živou kameru. Zvolit soubory je jen pro výběr z galerie. Jasné snímky obličeje — žádné filtry, které skrývají identitu. Max {max}.",
      "cameraTitle": "Vyfoťte sebe",
      "signIn": "Před nahráním fotografií se přihlaste.",
      "someFailed": "Některé fotografie se nepodařilo nahrát. Opakujte ty neúspěšné.",
      "addFailed": "Fotografie nelze přidat."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Zavřít",
      "capture": "Zachytit",
      "cancel": "Zrušit",
      "hint": "Držte stabilně. Živá kamera zůstane otevřená, dokud nezachytíte.",
      "unavailable": "Kamera v tomto prohlížeči není dostupná. Místo toho použijte Zvolit soubor.",
      "permissionDenied": "Oprávnění kamery odepřeno nebo nedostupné. Místo toho použijte Zvolit soubor.",
      "frameFailed": "Tento snímek nelze zachytit.",
      "saveFailed": "Fotografii nelze uložit."
    },
    "uploadStatus": {
      "uploading": "nahrávání…",
      "failed": "nahrání selhalo",
      "savedLocally": "uloženo lokálně",
      "uploaded": "nahráno",
      "stored": "uloženo",
      "awaitingUpload": "Čeká na nahrání",
      "localFallbackNote": "{error} Soubor je uložen v tomto zařízení; zkuste znovu, až bude sign endpoint dostupný."
    }
  },
  "language": {
    "label": "Jazyk",
    "choose": "Zvolit jazyk"
  },
  "shell": {
    "back": "Zpět",
    "goBackAria": "Zpět"
  }
} as Messages;
